(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/javascripts/utils/format.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/javascripts/utils/format.js');

'use strict';

function formatDistance(distance) {
  distance = parseInt(distance, 10);
  if (distance >= 10000) {
    return "".concat((distance / 1000).toFixed(1).replace('.0', ''), " km").replace('.', ',');
  } else if (distance > 1) {
    return "".concat(distance.toLocaleString('en').replace(/,/g, ' '), " m");
  }
  return '1 m';
}

const getDistance = _ref => {
  let from = _ref.from,
    to = _ref.to,
    _ref$subMeter = _ref.subMeter,
    subMeter = _ref$subMeter === void 0 ? 0 : _ref$subMeter,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? true : _ref$format;
  const lat1 = from[0];
  const lon1 = from[1];
  const lat2 = to[0];
  const lon2 = to[1];
  const R = 6371000;
  const diffLat = (lat2 - lat1) * (Math.PI / 180);
  const diffLon = (lon2 - lon1) * (Math.PI / 180);
  const a = Math.sin(diffLat / 2) * Math.sin(diffLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(diffLon / 2) * Math.sin(diffLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distanceInMeters = R * c - subMeter;
  if (!format) {
    return distanceInMeters;
  }
  return formatDistance(distanceInMeters);
};
setGlobal('svs.lyckoplatsen.utils.format', {
  formatDistance,
  getDistance
});

 })(window);